export default {
  title: 'Project Name Detail Report',
  backButton: 'Back to all reports',
  adminBackButton: 'Back to MBD Reports',
};
